import { Autocomplete, ButtonGroup, createStyles, makeStyles } from '@forgeglobal/design-framework'
import { transformAdminTypeahead } from 'components/shared/dropdowns'
import { useAdminTypeAheadQuery, useAppDataQuery } from 'graphql/bindings/AdminBindings'
import React, { Fragment, useState } from 'react'

import { OpportunitiesTables } from './OpportunitiesTables'

const useStyles = makeStyles(({ palette, spacing }) =>
  createStyles({
    controlBarContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'top',
    },
    buttonGroupContainer: {
      width: '100%',
    },
    formContainer: {
      width: '45vw',
    },
    ownerPickerContainer: {
      minWidth: '35vw',
    },
  })
)

interface DashboardOpportunitiesProps {}

export const DashboardOpportunities: React.FC<DashboardOpportunitiesProps> = () => {
  const classes = useStyles()
  const [selectedTradeIntentTypes, setSelectedTradeIntentTypes] = useState(['bids', 'asks'])
  const { data } = useAppDataQuery()
  const defaultUser = { label: data?.currentAdmin.name ?? '', value: data?.currentAdmin.id ?? 0 }
  const [owners, setOwners] = useState([defaultUser])

  const handleChange = (e: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => {
    setSelectedTradeIntentTypes(value)
  }

  return (
    <Fragment>
      <div className={classes.controlBarContainer}>
        <div className={classes.ownerPickerContainer}>
          <OwnerPicker handleChange={setOwners} value={owners} />
        </div>
        <BidAskToggle value={selectedTradeIntentTypes} onChange={handleChange} />
      </div>
      <OpportunitiesTables
        tableVariant={'dashboard'}
        displayedTables={selectedTradeIntentTypes}
        owners={owners.map(owner => owner.value).flat()}
      />
    </Fragment>
  )
}

type owners = { label: string; value: number }[]

interface OwnerPickerProps {
  handleChange: (owners: owners) => void
  value: { label: string; value: number }[]
}

export const OwnerPicker: React.FC<OwnerPickerProps> = ({ handleChange, value }) => {
  const { data, refetch } = useAdminTypeAheadQuery({
    variables: {
      query: '',
    },
  })
  const options = data ? transformAdminTypeahead(data) : []
  const onInputChange = (value: any) => {
    refetch({ query: value as string } as any)
  }
  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={handleChange as any}
      label="Owners"
      onInputChange={onInputChange}
      multiple
    />
  )
}

interface BidAskToggleProps {
  value: string[]
  onChange?: (event: React.MouseEvent<HTMLElement, MouseEvent>, value: any) => void
}

export const BidAskToggle: React.FC<BidAskToggleProps> = ({ value, onChange }) => {
  return (
    <ButtonGroup
      onChange={onChange}
      value={value}
      options={[
        { label: 'Bids', value: 'bids' },
        { label: 'Asks', value: 'asks' },
      ]}
      size={'large'}
    />
  )
}
